import React, { useState } from 'react';
import PromptHistoryDrawer from './PromptHistoryDrawer';
import PromptAIUpdateDrawer from './PromptAIUpdateDrawer';
import './PromptTools.css';

const PromptTools = ({ agentId, onApplyAiPrompt }) => {
  const [ui, setUi] = useState({ isHistoryOpen: false, isAiOpen: false });
  const updateUi = (patch) => setUi((prev) => ({ ...prev, ...patch }));

  return (
    <div className="agent-prompt-tools">
      <button className="agent-prompt-tools-btn agent-prompt-tools-ai-btn" onClick={() => updateUi({ isAiOpen: true })} title="Improve with AI">
        <i className="fa fa-magic" />
      </button>
      <button className="agent-prompt-tools-btn agent-prompt-tools-history-btn" onClick={() => updateUi({ isHistoryOpen: true })} title="Prompt history">
        <i className="fa fa-history" />
      </button>
      <PromptHistoryDrawer isOpen={ui['isHistoryOpen']} onClose={() => updateUi({ isHistoryOpen: false })} agentId={agentId} />
      <PromptAIUpdateDrawer isOpen={ui['isAiOpen']} onClose={() => updateUi({ isAiOpen: false })} agentId={agentId} onApprove={onApplyAiPrompt} />
    </div>
  );
};

export default PromptTools;
